/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from "react";
import {
  Container,
  List,
  Segment,
  Grid,
  //GridRow,
  GridColumn,
  //Icon,
  //Button,
  //ButtonContent,
} from "semantic-ui-react";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import { UniversalLink } from "@plone/volto/components";

import { useGoogleAnalytics } from 'volto-google-analytics';
const messages = defineMessages({
  copyright: {
    id: "Copyright",
    defaultMessage: "Copyright",
  },
});

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  useGoogleAnalytics();
  return (
    <div class="footer-container print_hide">
      <Segment
        role="contentinfo"
        vertical
        padded
        inverted
        id="footer"
        aria-label="Footer"
      >
        <div>
          <div id="footer-main">
            <div>
              <Grid padded stackable>
                <GridColumn width={4} textAlign="left" className="columnborder">
                  <p>
                    The National Education Directory — connecting South Africa's
                    education ecosystem.
                  </p>
                </GridColumn>
                <GridColumn width={2}></GridColumn>
                <GridColumn width={3} textAlign="left" className="columnborder">
                  <List>
                    <List.Header>Portal</List.Header>
                    <List.Content>
                      <List.Item>
                        <UniversalLink
                          href="https://portal.nedconnect.org/login"
                          target="_blank"
                        >
                          Log in
                        </UniversalLink>
                      </List.Item>
                      <List.Item>
                        <UniversalLink
                          href="https://portal.nedconnect.org/sign-up"
                          target="_blank"
                        >
                          Sign up
                        </UniversalLink>
                      </List.Item>
                      <List.Item>
                        <UniversalLink
                          href="https://portal.nedconnect.org/apply-new-organisation"
                          target="_blank"
                        >
                          Add your Organisation
                        </UniversalLink>
                      </List.Item>
                      <List.Item>
                        <UniversalLink
                          href="https://analytics.zoho.com/open-view/3002035000007666071"
                          target="_blank"
                        >
                          View the Dashboard
                        </UniversalLink>
                      </List.Item>
                      <List.Item>
                        <UniversalLink href="mailto:ned@nascee.org.za">
                          Contact
                        </UniversalLink>
                      </List.Item>
                    </List.Content>
                  </List>
                </GridColumn>
                <GridColumn width={3} textAlign="left" className="columnborder">
                  <List>
                    <List.Header>Legal</List.Header>
                    <List.Content>
                      <List.Item>
                        <UniversalLink href="/privacy-policy">
                          Privacy Policy
                        </UniversalLink>
                      </List.Item>
                      <List.Item>
                        <UniversalLink href="/terms-of-use">
                          Terms of use
                        </UniversalLink>
                      </List.Item>
                      <List.Item>
                        <UniversalLink href="/popia-notice">
                          POPIA Notice
                        </UniversalLink>
                      </List.Item>
                      <List.Item>
                        <br />
                      </List.Item>
                    </List.Content>
                  </List>
                  <List>
                    <List.Header>Driven by</List.Header>
                    <List.Content>
                      <List.Item>
                        <UniversalLink
                          href="https://nascee.org.za"
                          target="_blank"
                        >
                          NASCEE <i class="bi bi-arrow-right"></i>
                        </UniversalLink>
                      </List.Item>
                    </List.Content>
                  </List>
                </GridColumn>
              </Grid>
            </div>
            <div>
              <FormattedMessage
                id="{copyright} NED Connect {current_year}"
                defaultMessage="{copyright} NED Connect {current_year}"
                values={{
                  copyright: (
                    <abbr title={intl.formatMessage(messages.copyright)}>
                      ©
                    </abbr>
                  ),
                  current_year: new Date().getFullYear(),
                }}
              />
            </div>
          </div>
        </div>
      </Segment>
      <div class="belowFooter">
        <a href="https://juizi.com" target="_blank" rel="noreferrer">
          <img src="https://juizi.com/juizi.png" />
        </a>
      </div>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
